var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28431 0.588591C9.08944 0.453595 8.82001 0.47288 8.64645 0.646447L8.58859 0.715695C8.4536 0.910563 8.47288 1.17999 8.64645 1.35355L14.793 7.5H0.5L0.410124 7.50806C0.176875 7.55039 0 7.75454 0 8C0 8.27614 0.223858 8.5 0.5 8.5H14.793L8.64645 14.6464L8.58859 14.7157C8.4536 14.9106 8.47288 15.18 8.64645 15.3536C8.84171 15.5488 9.15829 15.5488 9.35355 15.3536L16.3536 8.35355L16.4114 8.28431C16.5464 8.08944 16.5271 7.82001 16.3536 7.64645L9.35355 0.646447L9.28431 0.588591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.28cf2875cdf56b84c4d4a0db394a2d23.svg";
export { ForwardRef as ReactComponent };